/* MV Sortiment assets/mv-sortiment.h2.js - Agent T-H2 - 2026-10-04
 *
 * Modul "inhaltsseiten" fuer die ueberarbeiteten Inhaltsseiten (Design-Runde T-H2). Teil von
 * assets/mv-sortiment.js (_build/konkat.sh), laedt allein und in beliebiger Reihenfolge. Nur Delegation auf
 * document, kein Zustand ausser im DOM: Sektionen, die der Theme-Editor neu laedt, funktionieren sofort.
 *
 *  1. Finanzierung (sections/mv-finanzierung.liquid): Umschalter [data-mv-fin] mit Radios [data-mv-fin-wahl]
 *     (Werte kauf, leasing, miete). Nach jeder Wahl bekommt jedes Element mit [data-mv-fin-nur] im selben
 *     [data-mv-fin] das Attribut hidden, wenn seine Liste (Wege durch Leerzeichen getrennt) den gewaehlten Weg
 *     nicht enthaelt; das gewaehlte Segment (label) traegt data-mv-aktiv; [data-mv-fin-status] (aria-live)
 *     meldet den Weg nach einer Wahl. Links [data-mv-fin-waehle="<weg>"] (Vergleichskarten) waehlen den Weg im
 *     Umschalter derselben Sektion ([data-mv-fin-bereich]); der Sprung zum Anker bleibt Sache des Browsers.
 *     Beim Laden, nach shopify:section:load und bei pageshow wird auf das gewaehlte Radio abgeglichen (Browser
 *     stellen Formularzustaende wieder her; die Radios tragen zusaetzlich autocomplete="off").
 *  2. Rechenbeispiel (sections/mv-branche-empfehlung.liquid): Plus/Minus [data-mv-kennzahl-schritt="<delta>"]
 *     aendern das Eingabefeld [data-mv-rechner-feld] derselben Kachel (.mv-kennzahlen__kachel bzw. das Feld aus
 *     aria-controls) in festen Schritten, Grenzen data-mv-kennzahl-min / -max, Nachkommastellen
 *     data-mv-kennzahl-dezimalen, und loesen ein input-Ereignis aus. Das Rechnen bleibt bei
 *     assets/mv-sortiment.rechner.js (Agent T-D). Die Knoepfe sind serverseitig hidden und werden hier
 *     freigeschaltet; ohne JS bleiben die Eingabefelder bedienbar.
 *
 * Waechter wie die uebrigen Teile: window.__mvSortiment.inhaltsseiten. Die reinen Funktionen sind fuer
 * Node-Tests ueber module.exports erreichbar (_tests/th2-seiten.test.mjs). Kommentare ASCII.
 */
;(function () {
  'use strict';

  var VERSION = '2026-10-04.1';
  var WEGE = ['kauf', 'leasing', 'miete'];

  /* "leasing miete" -> ['leasing', 'miete'] */
  function nurListe(wert) {
    return String(wert === null || wert === undefined ? '' : wert).split(/\s+/).filter(Boolean);
  }

  /* Ein Element ohne Liste gilt fuer jeden Weg */
  function sichtbarFuer(nur, weg) {
    var liste = nurListe(nur);
    return liste.length === 0 || liste.indexOf(weg) !== -1;
  }

  /* Deutsche und englische Schreibweise: "2,50", "2.5", "1.234,5", "1.234", " 40 % " -> Zahl, sonst NaN */
  function zahlLesen(wert) {
    if (typeof wert === 'number') return isFinite(wert) ? wert : NaN;
    if (wert === null || wert === undefined) return NaN;
    var s = String(wert).replace(/[\s\u00a0\u20ac%]/g, '');
    if (!s) return NaN;
    if (s.indexOf(',') !== -1) {
      s = s.replace(/\./g, '').replace(',', '.');
    } else if (/^\d{1,3}(\.\d{3})+$/.test(s)) {
      s = s.replace(/\./g, '');
    }
    if (!/^-?\d+(\.\d+)?$/.test(s)) return NaN;
    return parseFloat(s);
  }

  /* Zahl fuer ein Eingabefeld: feste Nachkommastellen, Komma als Trenner, ohne Tausenderpunkt */
  function zahlSchreiben(n, dezimalen) {
    var d = Math.max(0, Math.min(4, parseInt(dezimalen, 10) || 0));
    if (!isFinite(n)) return '';
    return n.toFixed(d).replace('.', ',');
  }

  /* Neuer Wert nach einem Schritt; ungueltiger Ausgangswert startet bei min (sonst 0); Grenzen eingehalten */
  function schritt(wert, delta, min, max, dezimalen) {
    var d = Math.max(0, Math.min(4, parseInt(dezimalen, 10) || 0));
    var faktor = Math.pow(10, d);
    var unten = zahlLesen(min);
    var oben = zahlLesen(max);
    var z = zahlLesen(wert);
    if (!isFinite(z)) z = isFinite(unten) ? unten : 0;
    var neu = Math.round((z + zahlLesen(delta)) * faktor) / faktor;
    if (!isFinite(neu)) neu = z;
    if (isFinite(unten) && neu < unten) neu = unten;
    if (isFinite(oben) && neu > oben) neu = oben;
    return zahlSchreiben(neu, d);
  }

  var logik = {
    VERSION: VERSION,
    WEGE: WEGE,
    nurListe: nurListe,
    sichtbarFuer: sichtbarFuer,
    zahlLesen: zahlLesen,
    zahlSchreiben: zahlSchreiben,
    schritt: schritt
  };

  if (typeof module === 'object' && module && module.exports) {
    module.exports = logik;
  }
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  /* Waechter (siehe Kopf) */
  var MV = window.__mvSortiment = window.__mvSortiment || {};
  if (MV.inhaltsseiten) return;
  MV.inhaltsseiten = logik;

  function alle(wurzel, selektor) {
    return wurzel && wurzel.querySelectorAll ? Array.prototype.slice.call(wurzel.querySelectorAll(selektor)) : [];
  }

  /* ---------------------------------------------------------------- 1. Finanzierung */

  function gewaehlt(wurzel) {
    var radio = wurzel.querySelector('[data-mv-fin-wahl]:checked');
    return radio ? radio.value : '';
  }

  function zeigeWeg(wurzel, melden) {
    var weg = gewaehlt(wurzel);
    if (WEGE.indexOf(weg) === -1) return;
    alle(wurzel, '[data-mv-fin-nur]').forEach(function (el) {
      var zeigen = sichtbarFuer(el.getAttribute('data-mv-fin-nur'), weg);
      if (zeigen && el.hasAttribute('hidden')) el.removeAttribute('hidden');
      if (!zeigen && !el.hasAttribute('hidden')) el.setAttribute('hidden', '');
    });
    var text = '';
    alle(wurzel, '[data-mv-fin-wahl]').forEach(function (radio) {
      var segment = radio.closest('label');
      if (!segment) return;
      if (radio.checked) {
        segment.setAttribute('data-mv-aktiv', '');
        text = (segment.textContent || '').replace(/\s+/g, ' ').trim();
      } else {
        segment.removeAttribute('data-mv-aktiv');
      }
    });
    var status = wurzel.querySelector('[data-mv-fin-status]');
    if (status && melden && text) status.textContent = 'Ablauf und Hinweise f\u00fcr ' + text;
  }

  function abgleichen(bereich) {
    var wurzel = bereich && bereich.querySelectorAll ? bereich : document;
    var liste = alle(wurzel, '[data-mv-fin]');
    if (wurzel.matches && wurzel.matches('[data-mv-fin]')) liste.unshift(wurzel);
    liste.forEach(function (fin) { zeigeWeg(fin, false); });
  }

  document.addEventListener('change', function (ereignis) {
    var radio = ereignis.target;
    if (!radio || !radio.closest || !radio.matches || !radio.matches('[data-mv-fin-wahl]')) return;
    var wurzel = radio.closest('[data-mv-fin]');
    if (wurzel) zeigeWeg(wurzel, true);
  });

  document.addEventListener('click', function (ereignis) {
    var ziel = ereignis.target;
    var link = ziel && ziel.closest ? ziel.closest('[data-mv-fin-waehle]') : null;
    if (!link) return;
    var weg = link.getAttribute('data-mv-fin-waehle');
    if (WEGE.indexOf(weg) === -1) return;
    var bereich = link.closest('[data-mv-fin-bereich]') || document;
    var wurzel = bereich.querySelector('[data-mv-fin]');
    if (!wurzel) return;
    var radio = wurzel.querySelector('[data-mv-fin-wahl][value="' + weg + '"]');
    if (!radio) return;
    radio.checked = true;
    zeigeWeg(wurzel, true);
    /* Fokus ins Segment, gescrollt wird ueber den Anker des Links */
    try { radio.focus({ preventScroll: true }); } catch (_) { radio.focus(); }
  });

  /* ---------------------------------------------------------------- 2. Rechenbeispiel */

  function feldZu(knopf) {
    var id = knopf.getAttribute('aria-controls');
    var feld = id ? document.getElementById(id) : null;
    if (!feld) {
      var kachel = knopf.closest('.mv-kennzahlen__kachel');
      feld = kachel ? kachel.querySelector('[data-mv-rechner-feld]') : null;
    }
    return feld;
  }

  function knoepfeFreigeben(bereich) {
    var wurzel = bereich && bereich.querySelectorAll ? bereich : document;
    alle(wurzel, '[data-mv-kennzahl-schritt][hidden]').forEach(function (knopf) {
      if (feldZu(knopf)) knopf.removeAttribute('hidden');
    });
  }

  document.addEventListener('click', function (ereignis) {
    var ziel = ereignis.target;
    var knopf = ziel && ziel.closest ? ziel.closest('[data-mv-kennzahl-schritt]') : null;
    if (!knopf) return;
    var feld = feldZu(knopf);
    if (!feld) return;
    ereignis.preventDefault();
    var neu = schritt(
      feld.value,
      knopf.getAttribute('data-mv-kennzahl-schritt'),
      feld.getAttribute('data-mv-kennzahl-min'),
      feld.getAttribute('data-mv-kennzahl-max'),
      feld.getAttribute('data-mv-kennzahl-dezimalen')
    );
    if (neu === '' || neu === feld.value) return;
    feld.value = neu;
    var ev;
    try {
      ev = new Event('input', { bubbles: true });
    } catch (_) {
      ev = document.createEvent('Event');
      ev.initEvent('input', true, false);
    }
    feld.dispatchEvent(ev);
  });

  /* ---------------------------------------------------------------- Start, Theme-Editor, Zurueck-Navigation */

  function start(bereich) {
    abgleichen(bereich);
    knoepfeFreigeben(bereich);
  }

  document.addEventListener('shopify:section:load', function (ereignis) {
    start(ereignis.target);
  });
  window.addEventListener('pageshow', function () {
    abgleichen(document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(document); });
  } else {
    start(document);
  }
})();
